<template>
    <div v-loading="loading">
        <div>
            <!-- 刷新按钮 -->
            <el-button type="primary" @click="refsh" class="refsh" size="mini">{{ $t('lang.repeater.refsh') }}</el-button>
            <el-tabs v-model="activeName">
                <!-- 通用 -->
                <el-tab-pane :label="$t('lang.repeater.universal')" name="default">
                    <h3>{{ $t('lang.repeater.serverConfig') }}</h3>
                    <!-- 下划线 -->
                    <el-divider></el-divider>
                    <el-form :model="server" label-width="200px">
                        <el-form-item :label="$t('lang.network.enabled') + ':'">
                            <el-checkbox v-model="server.enabled"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="$t('lang.smartele.server') + ':'">
                            <!-- 循环server.server -->
                            <div v-for="(item, index) in server.server" :key="index" class="input_box">
                                <el-input v-model="server.server[index]" size="mini" class="input"></el-input>
                                <el-button v-if="index === server.server.length - 1" type="primary" size="mini"
                                    @click="server.server.push('')">+</el-button>
                                <el-button v-else type="danger" size="mini"
                                    @click="server.server.splice(index, 1)">-</el-button>
                            </div>
                        </el-form-item>
                        <!-- 客户id -->
                        <el-form-item :label="$t('lang.smartele.customerID') + ':'">
                            <el-input v-model="server.mqtt_cid" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- 用户名 -->
                        <el-form-item :label="$t('lang.user.User') + ':'">
                            <el-input v-model="server.username" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- 密码 -->
                        <el-form-item :label="$t('lang.smartlink.password') + ':'">
                            <el-input v-model="server.password" type="password" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- 订阅主题 -->
                        <el-form-item :label="$t('lang.smartlink.subscribeTopics') + ':'">
                            <el-input v-model="server.topic_sub" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- 上报主题 -->
                        <el-form-item :label="$t('lang.smartlink.reportingSubject') + ':'">
                            <el-input v-model="server.topic_pub" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- MQTT服务质量 -->
                        <el-form-item :label="$t('lang.smartele.MQTTQualityofService') + ':'">
                            <el-select v-model="server.mqtt_qos" size="mini" class="input">
                                <el-option label="0" value="0"></el-option>
                                <el-option label="1" value="1"></el-option>
                                <el-option label="2" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- MQTT保活周期 -->
                        <el-form-item :label="$t('lang.smartlink.MqttSurvivalCycel') + ':'">
                            <el-input v-model="server.mqtt_alive" size="mini" class="input"></el-input>
                        </el-form-item>
                        <!-- 会话清理 -->
                        <el-form-item :label="$t('lang.smartele.sessionCleanup') + ':'">
                            <el-checkbox v-model="server.clean_session"></el-checkbox>
                        </el-form-item>
                        <!-- 保留信息 -->
                        <el-form-item :label="$t('lang.smartele.keepInformation') + ':'">
                            <el-checkbox v-model="server.retain"></el-checkbox>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item label="状态:" class="save">
                            <el-tag type="success" v-if="server.status === 'connected'">{{ $t('lang.Monitor.connected')
                            }}</el-tag>
                            <el-tag type="danger" v-else>{{ $t('lang.Monitor.disconnected') }}</el-tag>
                        </el-form-item>
                    </el-form>
                    <!-- 水平线 -->
                    <el-divider></el-divider>
                    <!-- 策略配置 -->
                    <h3>{{ $t('lang.smartele.policyConfiguration') }}</h3>
                    <!-- 下划线 -->
                    <el-divider></el-divider>
                    <el-tabs type="border-card">
                        <el-tab-pane :label="$t('lang.smartele.EscalationPolicy')">
                            <el-form :model="report" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.EscalationPolicy') + ':'">
                                    <el-select v-model="report.reportStrategy" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.ReportRegularly')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.ChangeReporting')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.variableList.triggerType') + ':'">
                                    <el-select v-model="report.reportType" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.ReportAllAttributes')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.NonFullAttributeReporting')"
                                            value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.variableList.triggerPeriod') + ':'"
                                    v-show="report.reportStrategy == 1">
                                    <el-input v-model="report.reportInterval" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item label="上报频率上限:" v-show="report.reportStrategy == 2">
                                    <el-input size="mini" class="input" v-model="report.reportRateUpper"></el-input>
                                    <p class="tips">s/次</p>
                                </el-form-item>
                                <el-form-item label="上报频率下限:" v-show="report.reportStrategy == 2">
                                    <el-input size="mini" class="input" v-model="report.reportRateLower"></el-input>
                                    <p class="tips">h/次</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.speed')">
                            <el-form :model="speed" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="speed.velCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="speed.velCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="speed.velCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">mm/s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.acceleration')">
                            <el-form :model="acceleration" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.toward')+':'">
                                    <el-select v-model="acceleration.aspect" size="mini">
                                        <el-option :label="$t('lang.smartele.LOGOFacingUp')" value="0"></el-option>
                                        <el-option :label="$t('lang.smartele.lightUp')" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="acceleration.accCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="acceleration.accCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="acceleration.accCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">mm/s²</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.barometricPressure')">
                            <el-form :model="pressure" label-width="200px" :rules="pressureRules">
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="pressure.pressCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="pressure.pressCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="pressure.pressCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">pa</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.TheSamplingPeriod') + ':'" prop="axisInter">
                                    <el-input v-model="pressure.axisInter" size="mini" class="input"></el-input>
                                    <p class="tips">100 ~ 500ms，采集大气压数值周期</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.floatingValue') + ':'" prop="subPress">
                                    <el-input v-model="pressure.subPress" size="mini" class="input"></el-input>
                                    <p class="tips">0.0001 ~ 0.001Kpa，大气压波动小于该值，表示处于静止状态</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.NumberOfFloats') + ':'" prop="pressCount">
                                    <el-input v-model="pressure.pressCount" size="mini" class="input"></el-input>
                                    <p class="tips">2 ~ 10次，大气压波动范围超出浮动值的持续周期数，当超过配置的数值时，设备处于运动状态</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.high')">
                            <el-form :model="height" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="height.heightCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="height.heightCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="height.heightCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">mm</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.temperature')">
                            <el-form :model="temp" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="temp.tempCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="temp.tempCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="temp.tempCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">0.01℃</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.humidity')">
                            <el-form :model="humidity" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.ValueMethod') + ':'">
                                    <el-select v-model="humidity.humCfg1" size="mini" class="input">
                                        <el-option :label="$t('lang.smartele.averageValue')" value="1"></el-option>
                                        <el-option :label="$t('lang.smartele.instantaneousValue')" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.timeInterval') + ':'">
                                    <el-input v-model="humidity.humCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.ReportingThreshold') + ':'">
                                    <el-input v-model="humidity.humCfg3" size="mini" class="input"></el-input>
                                    <p class="tips">0.1%RH</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.DirectionOfMovement')">
                            <el-form :model="direction" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.motionTOstill') + ':'">
                                    <el-input v-model="direction.dirCfg1" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.stillToMoving') + ':'">
                                    <el-input v-model="direction.dirCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.doorStatus')">
                            <el-form :model="door" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.notClosedToClosed') + ':'">
                                    <el-input v-model="door.doorCfg1" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.closedToNotClosed') + ':'">
                                    <el-input v-model="door.doorCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.flatState')">
                            <el-form :model="floor" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.NonFlatLayerToFlatLayer') + ':'">
                                    <el-input v-model="floor.lvCfg1" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.FlatLayerToNonFlatLayer') + ':'">
                                    <el-input v-model="floor.lvCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.GrassrootsState')">
                            <el-form :model="base" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.NonGrassrootsToGrassroots') + ':'">
                                    <el-input v-model="base.blvCfg1" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.GrassrootsToNonGrassroots') + ':'">
                                    <el-input v-model="base.blvCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('lang.smartele.PersonnelStatus')">
                            <el-form :model="person" label-width="200px">
                                <el-form-item :label="$t('lang.smartele.noOneToSomeone') + ':'">
                                    <el-input v-model="person.personCfg1" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                                <el-form-item :label="$t('lang.smartele.someoneToNoOne') + ':'">
                                    <el-input v-model="person.personCfg2" size="mini" class="input"></el-input>
                                    <p class="tips">0.1s</p>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                    <!-- 下划线 -->
                    <el-divider></el-divider>
                    <!-- 串口 -->
                    <h3>{{ $t('lang.smartele.SerialPortConfiguration') }}</h3>
                    <!-- 下划线 -->
                    <el-divider></el-divider>
                    <el-table border :data="serialData" style="width: 100%">
                        <el-table-column prop="name" :label="$t('lang.dashboard.name')" width="180"></el-table-column>
                        <el-table-column prop="baudrate" :label="$t('lang.smartlink.baudRate')"></el-table-column>
                        <el-table-column prop="data_bits" :label="$t('lang.smartlink.dataBits')"></el-table-column>
                        <el-table-column prop="stop_bits" :label="$t('lang.smartlink.stopBits')"></el-table-column>
                        <el-table-column prop="parity_value" :label="$t('lang.smartlink.checkBits')"></el-table-column>
                        <el-table-column prop="flow_ctrl_value" :label="$t('lang.smartlink.flowControl')"></el-table-column>
                        <el-table-column :label="$t('lang.firmware.Operation')" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="primary" icon="el-icon-edit" circle
                                    @click="editSerial(scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="primary" style="margin-top: 1rem;" @click="updateConfig">{{
                        $t('lang.ConfigSetting.SaveApply') }}</el-button>
                </el-tab-pane>
                <el-tab-pane :label="$t('lang.smartlink.senior')" name="senior">
                    <h3>{{ $t('lang.IOControl.seniorConfig') }}</h3>
                    <!-- 下划线 -->
                    <el-divider></el-divider>
                    <el-form :model="senior" label-width="200px" :rules="seniorRule">
                        <el-form-item :label="$t('lang.IOControl.trueOn') + ':'">
                            <el-checkbox v-model="senior.enabled"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="$t('lang.IOControl.debug') + ':'">
                            <el-checkbox v-model="senior.enable_debug"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="$t('lang.smartele.DataUpdateCycle') + ':'" prop="updateInterval">
                            <el-input v-model="senior.updateInterval" size="mini" class="input"></el-input>
                            <p class="tips">>3s</p>
                        </el-form-item>
                        <el-form-item :label="$t('lang.IOControl.logNumber') + ':'" prop="log_file_num">
                            <el-input v-model="senior.log_file_num" size="mini" class="input"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('lang.IOControl.logSize') + ':'" prop="log_file_size">
                            <el-input v-model="senior.log_file_size" size="mini" class="input"></el-input>
                            <p class="tips">kb</p>
                        </el-form-item>
                        <el-form-item :label="$t('lang.IOControl.logPriority') + ':'">
                            <el-select v-model="senior.log_priority" size="mini" class="input">
                                <el-option v-for="item in LogPriorityList" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('lang.IOControl.logFile') + ':'">
                            <el-button type="primary" @click="downloadFile" size="mini">{{ $t('lang.smartlink.download')
                            }}</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 水平线 -->
                    <el-divider></el-divider>
                    <el-button type="primary" size="mini" @click="updateConfig">{{ $t('lang.IOControl.SaveApply')
                    }}</el-button>
                </el-tab-pane>
            </el-tabs>
        </div>
        <eleDialog @refresh="refsh" ref="eledialog" :deviceSn="deviceSn" :deviceDid="deviceDid"></eleDialog>
    </div>
</template>

<script>
import { listConfig, updateConfig, getLog } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import eleDialog from "./components/eleDialog.vue";
export default {
    name: "",
    props: ['deviceSn', 'deviceDid'],
    components: {
        eleDialog
    },
    data() {
        var validateUpdateInterval = (rule, value, callback) => {
            if (value < 3) {
                callback(new Error(this.$t('lang.smartele.updateInterval')));
            } else {
                callback();
            }
        };
        var validateLog_file_num = (rule, value, callback) => {
            if (value < 0) {
                callback(new Error(this.$t('lang.smartele.log_file_num')));
            } else {
                callback();
            }
        };
        var validateLog_file_size = (rule, value, callback) => {
            if (value < 0) {
                callback(new Error(this.$t('lang.smartele.log_file_size')));
            } else {
                callback();
            }
        };
        // 气压在100-500之间且只可以为数字
        var validatePressure = (rule, value, callback) => {
            if (value < 100 || value > 500) {
                callback(new Error(this.$t('lang.smartele.errorMsg')));
            } else {
                callback();
            }
        };
        // 浮动值在0.0001 ~ 0.001之间
        var validateFloat = (rule, value, callback) => {
            if (value < 0.0001 || value > 0.001) {
                callback(new Error(this.$t('lang.smartele.errorMsg')));
            } else {
                callback();
            }
        };
        // 浮动测试在2 ~ 10之间
        var validateFloatTest = (rule, value, callback) => {
            if (value < 2 || value > 10) {
                callback(new Error(this.$t('lang.smartele.errorMsg')));
            } else {
                callback();
            }
        };
        return {
            activeName: "default",
            server: {
                enabled: false,
                server: [""],
                mqtt_cid: '',
                username: '',
                password: '',
                topic_sub: '',
                topic_pub: '',
                mqtt_qos: '2',
                mqtt_alive: '',
                clean_session: '',
                retain: '',
                status: 'connected',
            },
            senior: {
                enabled: false,
                enable_debug: false,
                updateInterval: '0',
                log_file_num: '0',
                log_file_size: '0',
                log_priority: '0',

            },
            loading: true,
            LogPriorityList: [
                { value: '8', label: this.$t('lang.smartlink.debug') },
                { value: '7', label: this.$t('lang.smartlink.info') },
                { value: '6', label: this.$t('lang.smartlink.notice') },
                { value: '5', label: this.$t('lang.smartlink.alarm') },
                { value: '4', label: this.$t('lang.smartlink.error') },
                { value: '3', label: this.$t('lang.smartlink.deadly') },
                { value: '2', label: this.$t('lang.smartlink.alert') },
                { value: '1', label: this.$t('lang.smartlink.emergency') }
            ],
            seniorRule: {
                // updateInterval必填并且大于3
                updateInterval: [
                    { required: true, message: this.$t('lang.smartele.updateInterval'), trigger: 'blur' },
                    { validator: validateUpdateInterval, trigger: 'blur' }
                ],
                // log_file_num必填且大于0
                log_file_num: [
                    { required: true, message: this.$t('lang.smartele.log_file_num'), trigger: 'blur' },
                    { validator: validateLog_file_num, trigger: 'blur' }
                ],
                // log_file_size必填且大于0
                log_file_size: [
                    { required: true, message: this.$t('lang.smartele.log_file_size'), trigger: 'blur' },
                    { validator: validateLog_file_size, trigger: 'blur' }
                ],
            },
            report: {
                reportStrategy: '1',
                reportType: '1',
                reportInterval: '1',
                reportRateUpper: '1',
                reportRateLower: '24',
            },
            speed: {
                velCfg1: '1',
                velCfg2: '1',
                velCfg3: '10',
            },
            acceleration: {
                aspect: '1',
                accCfg1: '1',
                accCfg2: '1',
                accCfg3: '10',
            },
            pressure: {
                pressCfg1: '1',
                pressCfg2: '1',
                pressCfg3: '10',
                axisInter: '1',
                subPress: '1',
                pressCount: '1',
            },
            height: {
                heightCfg1: '1',
                heightCfg2: '1',
                heightCfg3: '10',
            },
            temp: {
                tempCfg1: '1',
                tempCfg2: '1',
                tempCfg3: '10',
            },
            humidity: {
                humCfg1: '1',
                humCfg2: '1',
                humCfg3: '10',
            },
            direction: {
                dirCfg1: '10',
                dirCfg2: '10',
            },
            door: {
                doorCfg1: '10',
                doorCfg2: '10',
            },
            floor: {
                lvCfg1: '10',
                lvCfg2: '10',
            },
            base: {
                blvCfg1: '10',
                blvCfg2: '10',
            },
            person: {
                personCfg1: '10',
                personCfg2: '10',
            },
            serialData: [],
            pressureRules: {
                axisInter: [
                    { required: true, message: this.$t('lang.smartele.errorMsg'), trigger: 'blur' },
                    { validator: validatePressure, trigger: 'blur' }
                ],
                // 浮动
                subPress: [
                    { required: true, message: this.$t('lang.smartele.errorMsg'), trigger: 'blur' },
                    { validator: validateFloat, trigger: 'blur' }
                ],
                // 浮动次数
                pressCount: [
                    { required: true, message: this.$t('lang.smartele.errorMsg'), trigger: 'blur' },
                    { validator: validateFloatTest, trigger: 'blur' }
                ],
            }
        };
    },
    async mounted() {
        await this.getConfig();
        await this.getSeniorConfig();
        this.loading = false;
    },
    methods: {
        // 获取配置
        getConfig() {
            return new Promise((resolve, reject) => {
                listConfig(this.deviceSn, this.deviceDid, [
                    {
                        config: 'smartele',
                        section: 'CLOUD',
                        options: [
                            {
                                option: 'enabled'
                            },
                            {
                                option: 'mqtt_cid'
                            },
                            {
                                option: 'username'
                            },
                            {
                                option: 'password'
                            },
                            {
                                option: 'topic_sub'
                            },
                            {
                                option: 'topic_pub'
                            },
                            {
                                option: 'mqtt_qos'
                            },
                            {
                                option: 'mqtt_alive'
                            },
                            {
                                option: 'clean_session'
                            },
                            {
                                option: 'retain'
                            },
                            {
                                option: 'status'
                            }
                        ],
                        lists: [
                            { list: 'server' }
                        ]
                    },
                    {
                        config: 'smartele',
                        section: 'policy',
                        options: [
                            {
                                option: 'reportStrategy'
                            },
                            {
                                option: 'reportType'
                            },
                            {
                                option: 'reportInterval'
                            },
                            {
                                option: 'reportRateUpper'
                            },
                            {
                                option: 'reportRateLower'
                            },
                            {
                                option: 'velCfg1'
                            },
                            {
                                option: 'velCfg2'
                            },
                            {
                                option: 'velCfg3'
                            },
                            {
                                option: 'aspect'
                            },
                            {
                                option: 'accCfg1'
                            },
                            {
                                option: 'accCfg2'
                            },
                            {
                                option: 'accCfg3'
                            },
                            {
                                option: 'pressCfg1'
                            },
                            {
                                option: 'pressCfg2'
                            },
                            {
                                option: 'pressCfg3'
                            },
                            {
                                option: 'axisInter'
                            },
                            {
                                option: 'subPress'
                            },
                            {
                                option: 'pressCount'
                            },
                            {
                                option: 'heightCfg1'
                            },
                            {
                                option: 'heightCfg2'
                            },
                            {
                                option: 'heightCfg3'
                            },
                            {
                                option: 'tempCfg1'
                            },
                            {
                                option: 'tempCfg2'
                            },
                            {
                                option: 'tempCfg3'
                            },
                            {
                                option: 'humCfg1'
                            },
                            {
                                option: 'humCfg2'
                            },
                            {
                                option: 'humCfg3'
                            },
                            {
                                option: 'dirCfg1'
                            },
                            {
                                option: 'dirCfg2'
                            },
                            {
                                option: 'doorCfg1'
                            },
                            {
                                option: 'doorCfg2'
                            },
                            {
                                option: 'lvCfg1'
                            },
                            {
                                option: 'lvCfg2'
                            },
                            {
                                option: 'blvCfg1'
                            },
                            {
                                option: 'blvCfg2'
                            },
                            {
                                option: 'personCfg1'
                            },
                            {
                                option: 'personCfg2'
                            }
                        ],
                    },
                    {
                        config: 'smartele',
                        section: 'serial',
                        options: [
                            {
                                option: 'baudrate'
                            },
                            {
                                option: 'data_bits'
                            },
                            {
                                option: 'stop_bits'
                            },
                            {
                                option: 'parity'
                            },
                            {
                                option: 'flow_ctrl'
                            },
                            {
                                option: 'enable_frame'
                            },
                            {
                                option: 'timeout'
                            },
                            {
                                option: 'frame_len'
                            },
                        ],
                    }
                ]).then(res => {
                    let options = res.data.data.mess[0].s_objects[0].options
                    this.server.enabled = options.enabled === '1' ? true : false;
                    this.server.mqtt_cid = options.mqtt_cid;
                    this.server.username = options.username;
                    this.server.password = options.password;
                    this.server.topic_sub = options.topic_sub;
                    this.server.topic_pub = options.topic_pub;
                    this.server.mqtt_qos = options.mqtt_qos;
                    this.server.mqtt_alive = options.mqtt_alive;
                    this.server.clean_session = options.clean_session === '1' ? true : false;
                    this.server.retain = options.retain === '1' ? true : false;
                    this.server.status = options.status;
                    this.server.server = res.data.data.mess[0].s_objects[0].lists.server;
                    let options2 = res.data.data.mess[1].s_objects[0].options;

                    this.report.reportStrategy = options2.reportStrategy;
                    this.report.reportType = options2.reportType;
                    this.report.reportInterval = options2.reportInterval;
                    this.report.reportRateUpper = options2.reportRateUpper;
                    this.report.reportRateLower = options2.reportRateLower;
                    this.speed.velCfg1 = options2.velCfg1;
                    this.speed.velCfg2 = options2.velCfg2;
                    this.speed.velCfg3 = options2.velCfg3;
                    this.acceleration.aspect = options2.aspect;
                    this.acceleration.accCfg1 = options2.accCfg1;
                    this.acceleration.accCfg2 = options2.accCfg2;
                    this.acceleration.accCfg3 = options2.accCfg3;
                    this.pressure.pressCfg1 = options2.pressCfg1;
                    this.pressure.pressCfg2 = options2.pressCfg2;
                    this.pressure.pressCfg3 = options2.pressCfg3;
                    this.pressure.axisInter = options2.axisInter;
                    this.pressure.subPress = options2.subPress;
                    this.pressure.pressCount = options2.pressCount;
                    this.height.heightCfg1 = options2.heightCfg1;
                    this.height.heightCfg2 = options2.heightCfg2;
                    this.height.heightCfg3 = options2.heightCfg3;
                    this.temp.tempCfg1 = options2.tempCfg1;
                    this.temp.tempCfg2 = options2.tempCfg2;
                    this.temp.tempCfg3 = options2.tempCfg3;
                    this.humidity.humCfg1 = options2.humCfg1;
                    this.humidity.humCfg2 = options2.humCfg2;
                    this.humidity.humCfg3 = options2.humCfg3;
                    this.direction.dirCfg1 = options2.dirCfg1;
                    this.direction.dirCfg2 = options2.dirCfg2;
                    this.door.doorCfg1 = options2.doorCfg1;
                    this.door.doorCfg2 = options2.doorCfg2;
                    this.floor.lvCfg1 = options2.lvCfg1;
                    this.floor.lvCfg2 = options2.lvCfg2;
                    this.base.blvCfg1 = options2.blvCfg1;
                    this.base.blvCfg2 = options2.blvCfg2;
                    this.person.personCfg1 = options2.personCfg1;
                    this.person.personCfg2 = options2.personCfg2;

                    let options3 = res.data.data.mess[2].s_objects;
                    options3.forEach(v => {
                        this.serialData.push({
                            baudrate: v.options.baudrate,
                            data_bits: v.options.data_bits,
                            stop_bits: v.options.stop_bits,
                            parity: v.options.parity,
                            flow_ctrl: v.options.flow_ctrl,
                            name: v.sname,
                            enable_frame: v.options.enable_frame == '1' ? true : false,
                            timeout: v.options.timeout,
                            frame_len: v.options.frame_len,
                            parity_value: this.keyValue(v.options.parity),
                            flow_ctrl_value: this.keyValue(v.options.flow_ctrl),
                        })
                    });
                    resolve();
                });
            });
        },
        keyValue(e) {
            switch (e) {
                case 'N':
                    return 'None'
                case 'S':
                    return 'Space'
                case 'E':
                    return 'Even'
                case 'M':
                    return 'Mark'
                case 'O':
                    return 'Odd'
                case 'X':
                    return 'XON/XOFF'
            }
        },
        // 更新配置
        async updateConfig() {
            this.loading = true;
            let server = this.server.server.map(v => v.trim()).filter(v => v !== '')
            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: 'smartele',
                    section: 'CLOUD',
                    action: 0,
                    index: [0],
                    options: {
                        enabled: this.server.enabled ? '1' : '0',
                        mqtt_cid: this.server.mqtt_cid,
                        username: this.server.username,
                        password: this.server.password,
                        topic_sub: this.server.topic_sub,
                        topic_pub: this.server.topic_pub,
                        mqtt_qos: this.server.mqtt_qos,
                        mqtt_alive: this.server.mqtt_alive,
                        clean_session: this.server.clean_session ? '1' : '0',
                        retain: this.server.retain ? '1' : '0',
                    },
                    lists: {
                        server
                    }
                },
                {
                    config: 'smartele',
                    section: 'policy',
                    action: 0,
                    index: [0],
                    options: {
                        ...this.report,
                        ...this.speed,
                        ...this.acceleration,
                        ...this.pressure,
                        ...this.height,
                        ...this.temp,
                        ...this.humidity,
                        ...this.direction,
                        ...this.door,
                        ...this.floor,
                        ...this.base,
                        ...this.person,
                    }
                }
            ])
            await updateConfig(this.deviceSn, this.deviceDid, [
                {
                    config: 'smartele',
                    section: 'service',
                    action: 0,
                    index: [0],
                    options: {
                        enabled: this.senior.enabled ? '1' : '0',
                        enable_debug: this.senior.enable_debug ? '1' : '0',
                        updateInterval: this.senior.updateInterval,
                        log_file_num: this.senior.log_file_num,
                        log_file_size: this.senior.log_file_size,
                        log_priority: this.senior.log_priority,
                    }
                }
            ]).then(res => {
                progressControl(
                    [{ process: "smartele", action: "restart", type: 0 }],
                    String(this.deviceDid),
                    this.deviceSn
                ).then((res) => {
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.getSeniorConfig().then(() => {
                        this.loading = false;
                    });
                });
            });
        },
        // 刷新
        async refsh() {
            this.loading = true;
            await this.getSeniorConfig()
            this.getConfig().then(() => {
                this.loading = false;
            });
        },
        getSeniorConfig() {
            return new Promise((resolve, reject) => {
                listConfig(this.deviceSn, this.deviceDid, [
                    {
                        config: 'smartele',
                        section: 'service',
                        options: [
                            {
                                option: 'enabled'
                            },
                            {
                                option: 'enable_debug'
                            },
                            {
                                option: 'updateInterval'
                            },
                            {
                                option: 'log_file_num'
                            },
                            {
                                option: 'log_file_size'
                            },
                            {
                                option: 'log_priority'
                            }
                        ],
                    }
                ]).then(res => {
                    let options = res.data.data.mess[0].s_objects[0].options
                    this.senior.enabled = options.enabled === '1' ? true : false;
                    this.senior.enable_debug = options.enable_debug === '1' ? true : false;
                    this.senior.updateInterval = options.updateInterval;
                    this.senior.log_file_num = options.log_file_num;
                    this.senior.log_file_size = options.log_file_size;
                    this.senior.log_priority = options.log_priority;
                    resolve();
                });
            });
        },
        downloadFile() {
            let params = {
                did: this.deviceDid,
                sn: this.deviceSn,
                mess: "smartele"
            }
            getLog(params).then(res => {
                let blob = new Blob([res.data], { type: 'application/octet-stream' });
                let fileName = 'log.txt';
                if ('download' in document.createElement('a')) { // 非IE下载
                    let elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        editSerial(e) {
            this.$refs.eledialog.show(e)
        }
    }
};
</script>
<style scoped>
h3 {
    font-size: 16px;
    line-height: 1;
    padding-bottom: 10px;
    margin-top: 10px;
}

.input {
    width: 300px;
    margin-bottom: 10px;
}

.input_box {
    width: 360px;
}

.save {
    /* 靠右侧 */
    margin-left: auto;
}

.refsh {
    position: absolute;
    right: 10px;
    z-index: 10;
}

.tips {
    color: #666;
    line-height: 10px;
}
</style>